__turbopack_context__.v({
  "custom": "sonner-module-scss-module__B35U3q__custom",
  "sonner-container": "sonner-module-scss-module__B35U3q__sonner-container",
  "sonner-icon": "sonner-module-scss-module__B35U3q__sonner-icon",
  "sonner-title": "sonner-module-scss-module__B35U3q__sonner-title",
});
